import { array, bool, func, object, string, number } from 'prop-types'
import { PureComponent } from 'react'
import { AnalyticsLayer, getTrackableComponent } from '@opallabs/quanta'
import Menu from '../../Menu'
import Dropdown from '../../PopoverV2/Dropdown'
import SelectTrigger from './SelectTrigger/index'

export default class Select extends PureComponent {
  static propTypes = {
    ariaLabel: string,
    arrowIcon: string,
    className: string,
    customFooter: object,
    disabled: bool,
    extraText: object,
    icon: string,
    iconOptions: object,
    isLoading: bool,
    name: string,
    noOptionsText: string,
    noOptionsElement: object,
    onChange: func,
    onSelect: func,
    options: array,
    placeholder: string,
    searchable: bool,
    selectedComparator: func,
    showDeselectIcon: bool,
    theme: string,
    trackers: object,
    truncateValueAt: number,
    value: object,
  }

  static defaultProps = {
    ariaLabel: 'Dropdown',
    arrowIcon: 'triangles-sm-ns',
    disabled: false,
    isLoading: false,
    placeholder: 'Select one...',
    searchable: false,
    showDeselectIcon: false,
    theme: 'dark',
    trackers: {},
    value: {},
  }

  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  get selectTrigger() {
    const {
      ariaLabel = '',
      arrowIcon,
      disabled,
      extraText,
      icon,
      iconOptions,
      isLoading,
      placeholder,
      theme,
      truncateValueAt,
      value,
    } = this.props
    return (
      <SelectTrigger
        ariaLabel={ariaLabel}
        arrowIcon={arrowIcon}
        disabled={disabled}
        extraText={extraText}
        hideText={value.hideText}
        icon={icon || value.icon}
        iconOptions={iconOptions}
        isLoading={isLoading}
        open={this.state.open}
        placeholder={placeholder}
        role="combobox"
        theme={theme}
        truncateValueAt={truncateValueAt}
        value={value.title}
      />
    )
  }

  get menu() {
    return (
      <Menu
        className={this.props.className}
        customFooter={this.props.customFooter}
        options={this.props.options}
        value={this.props.value}
        searchable={this.props.searchable}
        showDeselectIcon={this.props.showDeselectIcon}
        onSelect={this.onSelect}
        noOptionsText={this.props.noOptionsText}
        noOptionsElement={this.props.noOptionsElement}
        role="listbox"
        selectedComparator={this.props.selectedComparator}
      />
    )
  }

  onOpen = () => this.setState({ open: true }, this.doTracking('open'))

  onClose = () => this.setState({ open: false }, this.doTracking('close'))

  onSelect = (value) => {
    this.onClose()
    this.doTracking(value.title)
    if (this.props.onSelect) {
      return this.props.onSelect(value)
    }

    return this.props.onChange(value)
  }

  get track() {
    return this.props.trackers.track
  }

  doTracking = (val) => {
    if (this.track) {
      this.track('click', val)
    }
  }

  render() {
    if (this.props.disabled) {
      return this.selectTrigger
    }
    const { name } = this.props
    const context = name ? `${name} Select` : 'Select'

    return (
      <AnalyticsLayer name={context}>
        <Dropdown
          {...this.props}
          className={this.props.className}
          forceClose={!this.state.open}
          onOpen={this.onOpen}
          onClose={this.onClose}
          trigger={this.selectTrigger}
          content={this.menu}
        />
      </AnalyticsLayer>
    )
  }
}
Select.displayName = 'Kuiper: Select ← Inputs'

const TrackedSelect = getTrackableComponent(Select)
export { TrackedSelect }
